<template>
    <div 
      class="filters-list-wrapper d-flex align-items-center flex-wrap"
      :class="filters && filters.length ? 'has-filters' : ''">
        <template v-if="!filters.length">
          <p class="mb-0 d-none d-md-block">No Active Filters</p>
        </template>
        <a 
            href="#" 
            class="rw-filter-toggle oa-tool-tip" 
            :class="{ 'd-none': i >= maxNumFilters && showAll != 1 }"
            v-for="(filter, i) in filters" 
            :key="i"
            :aria-label="`Active ${filter.displayName} Filter: ${filter.text}`"
            @click.prevent="onRemoveFilter(filter.field)"
            :title="'Remove Filter'">
                <span class="rw-filter-toggle__text">{{ filter.text || filter.displayName }}</span>
                <i class="far fa-times"></i>
        </a>
        <a 
            v-if="filters.length > maxNumFilters"
            href="#" 
            class="rw-filter-toggle" 
            :aria-label="`Show ${numHiddenFilters} More Filters`"
            @click.prevent="toggleShowAll">
                <i 
                    :class="{
                        'far fa-plus': this.showAll == -1,
                        'far fa-times': this.showAll == 1
                    }">
                </i>
                <span class="rw-filter-toggle__text">
                    <template v-if="showAll == -1">
                        {{ numHiddenFilters }} more
                    </template>
                    <template v-else>
                        Less
                    </template>
                </span>
        </a>
    </div>
</template>

<script>
export default {
    props: {
        filters: {
            type: Array
        },
        maxNumFilters: {
            type: Number,
            default: 4
        },
        
    },
    data(){
        return {
            showAll: -1
        };
    },
    mounted (){},
    computed: {
        numHiddenFilters(){
            return this.filters.length - this.maxNumFilters;
        }
    },
    methods: {
        toggleShowAll(){ this.showAll *= -1; },
        onRemoveFilter(field){ 
            $('.oa-tool-tip').tooltip('hide');
            this.$emit('filter-click', field);
        }
    },
    watch: {
        filters(){ 
            window.initOATooltips(); 
        }
    }
};
</script>
